(function ($) {
  $(function () {
    var $resourceGrid = $(".resource-grid");

    if ($resourceGrid.length) {
      // Check if the page is '/blog' or '/client-stories'
      // Then apply filtering functionalities accordingly
      if ($resourceGrid.hasClass('post_type--post')) {
        var resourceGrid = (function () {
          // DOM Elements
          var $resourceGridFiltersBlock = $('.resource-grid__filter-block');
          var $resourceGridFilterSelect = $(".resource-grid__filter-block select");
          var $resourceGridItems = $('.resource-grid__items');
          var $resourceGridItem = $(".resource-grid__item");
          var $resourceGridPagination = $(".resource-grid .pagination");
          var $dropDownHead = $resourceGridFiltersBlock.find('.types-dropdown .dropdown');
          var isOpen = false; // Flag to track dropdown state
          // Filter variables
          var filterSelectedOptions = {
            arrSelectedCategory: []
          };
          var $filteredItems = $resourceGridItem;
          var countFilterResults = 0;
          // Pagination variables
          var countResourceCards = $resourceGridItem.length;
          var resourcesPerPage = 12;
        
          function selectBoxIt() {
            $resourceGridFilterSelect.selectBoxIt({
              showFirstOption: false,
              width: '100%'
            });
          }
        
          function initPagination() {
            if (countResourceCards > resourcesPerPage) {
              $resourceGridItem.addClass("show").slice(resourcesPerPage).addClass("hide");
        
              $resourceGridPagination.pagination({
                items: countResourceCards,
                itemsOnPage: resourcesPerPage,
                ellipsePageSet: false,
                onPageClick: function (pageNumber) {
                  switchPage(pageNumber);
                  smoothScrollTo($resourceGrid);

                  if ($('.footer-cta').length) {
                    if (!$('.footer-cta .lottie').hasClass('reset')) {
                      $('.footer-cta .lottie').addClass('reset');
                    }
                  }
                },
              });
        
              if (
                window.location.hash &&
                window.location.hash.substring(1).includes("page-")
              ) {
                var pageNumber = window.location.hash
                  .substring(1)
                  .replace("page-", "");
                var totalPagesCount = $resourceGridPagination.pagination("getPagesCount");
        
                if (pageNumber > 0 && pageNumber <= totalPagesCount) {
                  $resourceGridPagination.pagination("drawPage", pageNumber);
                  switchPage(pageNumber);
                }
              }
            } else {
              $resourceGridPagination.addClass("hide");
            }
          }
        
          function switchPage(pageNumber) {
            var showFrom = resourcesPerPage * (pageNumber - 1);
            var showTo = showFrom + resourcesPerPage;
        
            $resourceGridItem.addClass("hide");
            $resourceGridItem
              .filter(".show")
              .slice(showFrom, showTo)
              .removeClass("hide");
          }
        
          function smoothScrollTo($offset) {
            if ($offset.length) {
              $("html, body").animate(
                {
                  scrollTop:
                    $offset.offset().top - $(".navigation").outerHeight(),
                },
                700,
                "linear"
              );
            }
          }
        
          function handleFilterSelectOption(e, obj) {
            var type = obj.selectbox[0].options[0].text.trim();
            var text = obj.selectboxOption[0].textContent.trim();
            var value = obj.selectboxOption[0].value.trim();
        
            // Append '...' to selected option text before showing it on SelectBox
            addEllipsisToOptionText(obj);
            
            if (type === 'By Category') {
              // Since its not a multiple select, empty the array every time user changes value
              filterSelectedOptions.arrSelectedCategory.splice(0); // If its a multiple select, remove this line to add all selected values to array
              filterSelectedOptions.arrSelectedCategory.push(value);
        
              $resourceGridItem.filter('.show').removeClass('show');
              $resourceGridItem.filter('.filtered').removeClass('filtered');
          
              if (filterSelectedOptions.arrSelectedCategory.length > 0) {
                if (text === 'All' || value === 'All') {
                  $filteredItems = $resourceGridItem;
                } else {
                  $filteredItems = $resourceGridItem.filter(function(id, el) {
                    var arrCategories = $(el).attr('data-category').trim().split(',');
            
                    return isArraySimilar(arrCategories, filterSelectedOptions.arrSelectedCategory);
                  });
                }
          
                if ($filteredItems.length > 0) {
                  $resourceGridItem.not('.show').addClass('hide');
                  $filteredItems.removeClass('hide').addClass('show filtered');
                  appendResetButton();
          
                  countFilterResults = $filteredItems.length;
                }
              }
            }
        
            if (countFilterResults === 0) {
              appendNoResultsHtml();
            } else {
              removeNoResultsHtml();
              reinitPagination(countFilterResults);
            }
          }
        
          function handleResetBtnClick() {
            filterSelectedOptions = {
              arrSelectedCategory: []
            };
            $filteredItems = $resourceGridItem;
            countFilterResults = 0;
        
            resetFilters();
            removeResetButton();
            removeNoResultsHtml();
        
            $resourceGridItem.filter('.filtered').removeClass('filtered');
            $resourceGridItem.filter('.hide').removeClass('hide');
            $resourceGridItem.addClass('show');
        
            reinitPagination(countResourceCards);
          }
        
          function appendNoResultsHtml() {
            if (!$resourceGridItems.find('.no-result').length) {
              $resourceGridItem.addClass('hide');
              $resourceGridItems.append('<div class="no-result col-12 pt-md"><h3>No Results Found</h3></div>').closest('.resource-grid').addClass('no-results');
              $resourceGridPagination.addClass('hide');
            }
          }
        
          function removeNoResultsHtml() {
            if ($resourceGridItems.find('.no-result').length) {
              $resourceGridItems.find('.no-result').remove();
              $resourceGridItems.closest('.resource-grid').removeClass('no-results');
            }
          }
        
          function appendResetButton() {
            if (!$resourceGridFiltersBlock.find('.filter-reset').length) {
              $resourceGridFiltersBlock.append('<div class="col-12 col-sm-6 col-lg-4 col-xl-3 filter-reset mt-xs"><span class="reset-button">Clear All</span></div>');
            }
          }
        
          function removeResetButton() {
            if ($('.resource-grid .reset-button').length) {
              $('.filter-reset').remove();
            }
          }
        
          function resetFilters() {
            $resourceGridFilterSelect.each(function() {
              var defaultText = $(this).find('option[disabled="disabled"]').text();
              $(this).parent().find('.selectboxit-text').text(defaultText);
            });
          }
        
          function reinitPagination(countResourceCards) {
            if (countResourceCards > resourcesPerPage) {
              $resourceGridItem.filter('.show').slice(resourcesPerPage).addClass('hide');
              $resourceGridPagination.pagination('destroy');
              $resourceGridPagination.pagination('updateItems', countResourceCards);
              $resourceGridPagination.pagination('drawPage', 1);
              history.pushState('', document.title, window.location.pathname + window.location.search);
              $resourceGridPagination.removeClass('hide').pagination('redraw');
            } else {
              $resourceGridPagination.addClass('hide');
            }
          }

          function isArraySimilar(arr, target) {
            if (target.length > 0) {
              return arr.some(v => target.includes(v));
            }
        
            return true;
          }
        
          function addEllipsisToOptionText(obj) {
            if (obj.selectboxOption[0].text.length > 30) {
              $(obj.dropdown[0]).find('.selectboxit-text').text(obj.selectboxOption[0].textContent.substr(0, 23).concat('...'));
            }
          }

          function dropDownHandler(e) {
            // e.preventDefault();
            isOpen = !isOpen; // Toggle open/closed state
    
            $(this).toggleClass('dropdown--open', isOpen);
            $(this).find('.dropdown__menu').slideToggle(300);
          }

          function closeDropDown(event) {
            if (isOpen && !$(event.target).closest('.types-dropdown').length ) {
              $dropDownHead.removeClass('dropdown--open');
              $dropDownHead.find('.dropdown__menu').slideUp(300);
              isOpen = false;
            }
          }
        
          return {
            init: function () {
              selectBoxIt();
              initPagination();
              this.bindEvents();
            },
            bindEvents: function () {
              $resourceGridFilterSelect.bind({
                "option-click": handleFilterSelectOption
              });
        
              $resourceGridFiltersBlock.on('click', '.reset-button', handleResetBtnClick);
              $dropDownHead.on('click', dropDownHandler);
              $(document).on('click', closeDropDown);
            }
          };
        })();
        
        resourceGrid.init();
      } else {
        var resourceGrid = (function () {
          var $resourceCards = $(".resource-grid .card-wrapper");
          var $resourceCardContent = $(".resource-grid .resource-card__content");
          var $resourceCardsWrapper = $('.resource-grid .cards-wrapper');
          var $resourceFilterWrapper = $('.resource-grid__filter-block');
          var $resourceFilterSelect = $(".resource-grid__filter-block select");
          var $pagination = $(".resource-grid .pagination");
          var $resourceCardsAfterPaginationInit = [];
          var resourcesPerPage = 12;
          var numResourceCards = $resourceCards.length;
          var arrSelectedTypes = [];
          var arrSelectedContentType = [];
          var countSearchResult = 0;
  
          function selectBoxIt() {
            $resourceFilterSelect.selectBoxIt({
              showFirstOption: false,
              width: '100%'
            });
          }
  
          function initPagination() {
            if (numResourceCards > resourcesPerPage) {
              $resourceCards.addClass("show").slice(resourcesPerPage).addClass("hide");
  
              $pagination.pagination({
                items: numResourceCards,
                itemsOnPage: resourcesPerPage,
                onPageClick: function (pageNumber) {
                  switchPage(pageNumber);
                  smoothScrollTo($resourceGrid);
                  
                  if ($('.footer-cta').length) {
                    if (!$('.footer-cta .lottie').hasClass('reset')) {
                      $('.footer-cta .lottie').addClass('reset');
                    }
                  }
                },
              });
  
              $resourceCardsAfterPaginationInit = $(".resource-grid .card-wrapper");
  
              if (
                window.location.hash &&
                window.location.hash.substring(1).includes("page-")
              ) {
                var pageNumber = window.location.hash
                  .substring(1)
                  .replace("page-", "");
                var totalPagesCount = $pagination.pagination("getPagesCount");
  
                if (pageNumber > 0 && pageNumber <= totalPagesCount) {
                  $pagination.pagination("drawPage", pageNumber);
                  switchPage(pageNumber);
                }
              }
            } else {
              $pagination.addClass("hide");
            }
          }

          function preFilterUsingUrlParams() {
            if (getUrlParameterByName('sort')) {
              var sortSelectBox = $resourceFilterSelect.first().data("selectBox-selectBoxIt");

              sortSelectBox.selectOption(getUrlParameterByName('sort'));
              arrSelectedTypes.push(getUrlParameterByName('sort'));
              filterBySortFilter(arrSelectedTypes);

              $(window).on('load', function () {
                setTimeout(function () {
                  smoothScrollTo($resourceGrid)
                }, 120);
              });

              if (countSearchResult === 0) {
                appendNoResultsHtml();
              } else {
                removeNoResultsHtml();
                reinitPagination(countSearchResult);
              }
            } 
            
            if (getUrlParameterByName('type')) {
              var typeSelectBox = $resourceFilterSelect.last().data("selectBox-selectBoxIt");

              typeSelectBox.selectOption(getUrlParameterByName('type'));
              arrSelectedContentType.push(getUrlParameterByName('type'));
              filterByContent(arrSelectedContentType);

              $(window).on('load', function () {
                setTimeout(function () {
                  smoothScrollTo($resourceGrid)
                }, 120);
              });

              if (countSearchResult === 0) {
                appendNoResultsHtml();
              } else {
                removeNoResultsHtml();
                reinitPagination(countSearchResult);
              }
            }

            if (
              window.location.hash &&
              window.location.hash.substring(1).includes("page-")
            ) {
              var pageNumber = window.location.hash
                .substring(1)
                .replace("page-", "");
              var totalPagesCount = $pagination.pagination("getPagesCount");

              if (pageNumber > 0 && pageNumber <= totalPagesCount) {
                $pagination.pagination("drawPage", pageNumber);
                switchPage(pageNumber);
              }
            }
          }
  
          function switchPage(pageNumber) {
            var showFrom = resourcesPerPage * (pageNumber - 1);
            var showTo = showFrom + resourcesPerPage;
  
            $resourceCards.addClass("hide");
            $resourceCards
              .filter(".show")
              .slice(showFrom, showTo)
              .removeClass("hide");
          }
  
          function smoothScrollTo($offset) {
            if ($offset.length) {
              $("html, body").animate(
                {
                  scrollTop:
                    $offset.offset().top - $(".navigation").outerHeight(),
                },
                700,
                "linear"
              );
            }
          }
  
          function handleFilterSelectOption(e, obj) {
            var type = obj.selectbox[0].options[0].text.trim();
            var value = obj.selectboxOption[0].value;
  
            // Append '...' to selected option text before showing it on SelectBox
            addEllipsisToOptionText(obj);
            
            if (type === 'Sort By') {
              // Since its not a multiple select, empty the array every time user changes value
              // If its a multiple select, remove the line below to add all selected values to array
              arrSelectedTypes.splice(0);
              arrSelectedTypes.push(value);
              setUrlParameter('sort', value);
              filterBySortFilter(arrSelectedTypes);
            } else if (type === 'By Content Type') {
              // Since its not a multiple select, empty the array every time user changes value
              // If its a multiple select, remove the line below to add all selected values to array
              arrSelectedContentType.splice(0);
              arrSelectedContentType.push(value);
              setUrlParameter('type', value);
              filterByContent(arrSelectedContentType);
            }
  
            if (countSearchResult === 0) {
              appendNoResultsHtml();
            } else {
              removeNoResultsHtml();
              reinitPagination(countSearchResult);
            }
          }
  
          function filterBySort(arrSelectedTypes) {
            if (arrSelectedTypes.length > 0) {
              var $availableCards = $(".resource-grid .card-wrapper.filtered").length ? $(".resource-grid .card-wrapper.filtered") : $resourceCards;
  
              var $sortedCards = $availableCards.sort((a, b) => {
                var dataTypesA = $(a).attr('data-types').split(',');
                var dataTypesB = $(b).attr('data-types').split(',');
                
                if (isArraySimilar(dataTypesA, arrSelectedTypes) && !isArraySimilar(dataTypesB, arrSelectedTypes)) {
                  return -1;
                } else if (!isArraySimilar(dataTypesA, arrSelectedTypes) && isArraySimilar(dataTypesB, arrSelectedTypes)) {
                  return 1;
                } else {
                  return 0;
                }
              });
  
              if ($sortedCards.length > 0) {
                $sortedCards.removeClass('hide').addClass("show");
                $resourceCardsWrapper.empty().append($sortedCards);
                appendResetButton();
  
                countSearchResult = $sortedCards.length;
              }
            }
          }
  
          function filterBySortFilter(arrSelectedContentType) {
            var $availableCards = $(".resource-grid .card-wrapper");
  
            $availableCards.filter('.show').removeClass('show');
            $availableCards.filter('.filtered').removeClass('filtered');
  
            if (arrSelectedContentType.length > 0) {
              var $matchedCards = $availableCards.filter(function(id, el) {
                var arrContentType = $(el).attr('data-types').trim().split(',');
  
                return isArraySimilar(arrContentType, arrSelectedContentType);
              });
  
              if ($matchedCards.length > 0) {
                $availableCards.not('.show').addClass('hide');
                $matchedCards.removeClass('hide').addClass('show filtered');
                appendResetButton();
  
                countSearchResult = $matchedCards.length;
              }
            }
          }

          function filterByContent(arrSelectedContentType) {
            var $availableCards = $(".resource-grid .card-wrapper");
  
            $availableCards.filter('.show').removeClass('show');
            $availableCards.filter('.filtered').removeClass('filtered');
  
            if (arrSelectedContentType.length > 0) {
              var $matchedCards = $availableCards.filter(function(id, el) {
                var arrContentType = $(el).attr('data-content-type').trim().split(',');
  
                return isArraySimilar(arrContentType, arrSelectedContentType);
              });
  
              if ($matchedCards.length > 0) {
                $availableCards.not('.show').addClass('hide');
                $matchedCards.removeClass('hide').addClass('show filtered');
                appendResetButton();
  
                countSearchResult = $matchedCards.length;
              }
            }
          }
  
          function handleResetBtnClick() {
            $resourceCardsWrapper.empty().append($resourceCardsAfterPaginationInit);
            
            $resourceCards = $(".resource-grid .card-wrapper");
            $resourceCardContent = $(".resource-grid .resource-card__content");
            arrSelectedTypes = [];
            arrSelectedContentType = [];
            countSearchResult = 0;
  
            resetFilterSelect();
            resetUrlAndRemoveParameters();
            removeResetButton();
            removeNoResultsHtml();
            
            $resourceCardsWrapper.empty().append($resourceCards);
            $resourceCards.filter('.filtered').removeClass('filtered');
            $resourceCards.filter('.hide').removeClass('hide');
            $resourceCards.addClass('show');
  
            reinitPagination(numResourceCards);
          }
  
          function isArraySimilar(arr, target) {
            if (target.length > 0) {
              return arr.some(v => target.includes(v));
            }
  
            return true;
          }
  
          function matchCardsContentHeight($cards) {
            if ($resourceCardContent.length) {
              $resourceCardContent.matchHeight();
              return;
            } 
          }
  
          function appendNoResultsHtml() {
            if (!$resourceCardsWrapper.find('.no-result').length) {
              $resourceCards.addClass('hide');
              $resourceCardsWrapper.append('<div class="no-result col-12 pt-md"><h3>No Results Found</h3></div>').closest('.resource-grid').addClass('no-results');
              $pagination.addClass('hide');
            }
          }
  
          function removeNoResultsHtml() {
            if ($resourceCardsWrapper.find('.no-result').length) {
              $resourceCardsWrapper.find('.no-result').remove();
              $resourceCardsWrapper.closest('.resource-grid').removeClass('no-results');
            }
          }
  
          function appendResetButton() {
            if (!$resourceFilterWrapper.find('.filter-reset').length) {
              $resourceFilterWrapper.append('<div class="col-12 col-sm-6 col-lg-4 col-xl-3 filter-reset mt-xs"><span class="reset-button">Clear All</span></div>');
            }
          }
  
          function removeResetButton() {
            if ($('.resource-grid .reset-button').length) {
              $('.filter-reset').remove();
            }
          }
  
          function resetFilterSelect() {
            $(".resource-grid__filter-block select option[disabled='disabled']").each(function() {
              var defaultText = $(this).text();
              var defaultValue = $(this).val();
              var selectBox = $(this).closest('select').data('selectBox-selectBoxIt');

              selectBox.selectOption(defaultValue);
              $(this).closest('.filter-item').find('.selectboxit-text').text(defaultText);
            });
          }
  
          function reinitPagination(countResourceCards) {
            if (countResourceCards > resourcesPerPage) {
              var $availableCards = $(".resource-grid .card-wrapper");
              $availableCards.filter('.show').slice(resourcesPerPage).addClass('hide');
              $pagination.pagination('destroy');
              $pagination.pagination('updateItems', countResourceCards);
              $pagination.pagination('drawPage', 1);
              history.pushState('', document.title, window.location.pathname + window.location.search);
              $pagination.removeClass('hide').pagination('redraw');
            } else {
              $pagination.addClass('hide');
            }
          }
  
          function addEllipsisToOptionText(obj) {
            if (obj.selectboxOption[0].text.length > 30) {
              $(obj.dropdown[0]).find('.selectboxit-text').text(obj.selectboxOption[0].textContent.substr(0, 25).concat('...'));
            }
          }

          function getUrlParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
            var results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
          }

          function setUrlParameter(name, value) {
            // Get existing url parameters
            var sortValue = name === 'sort' ? value: getUrlParameterByName('sort');
            var typeValue = name === 'type' ? value: getUrlParameterByName('type');
            var baseUrl = `${window.location.origin}${window.location.pathname}`;

            // Build the new URL
            if (sortValue) {
              var newUrl = `${baseUrl}?sort=${encodeURIComponent(sortValue)}`;

              if (typeValue) {
                var newUrl = `${baseUrl}?sort=${encodeURIComponent(sortValue)}&type=${encodeURIComponent(typeValue)}`;
              }
            } else if (typeValue) {
              var newUrl = `${baseUrl}?type=${encodeURIComponent(typeValue)}`;
            }

            // Update the URL
            window.history.replaceState(null, null, newUrl);
          }

          function resetUrlAndRemoveParameters() {
            window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
          }
  
          return {
            init: function () {
              selectBoxIt();
              initPagination();
              preFilterUsingUrlParams();
              this.bindEvents();
            },
            bindEvents: function () {
              $resourceFilterSelect.bind({
                "option-click": handleFilterSelectOption
              });
  
              $resourceFilterWrapper.on('click', '.reset-button', handleResetBtnClick);
            },
            matchCardsContentHeight: matchCardsContentHeight,
          };
        })();
  
        resourceGrid.init();
  
        $(window).on('load resize', resourceGrid.matchCardsContentHeight);
      }
    }
  });
})(jQuery);
